import { useSearchParams } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

export function Pagination({ page, totalPages }: { page: number; totalPages: number }) {
  const [params, setParams] = useSearchParams();
  function go(p: number) {
    const next = new URLSearchParams(params);
    next.set('page', String(p));
    setParams(next);
  }
  return (
    <div className="mt-4 flex items-center justify-between text-sm text-muted-foreground">
      <span>
        Page {page} / {totalPages}
      </span>
      <div className="flex gap-2">
        <Button variant="ghost" size="sm" disabled={page <= 1} onClick={() => go(page - 1)}>
          <ChevronLeft size={14} strokeWidth={1.5} />
          Prev
        </Button>
        <Button
          variant="ghost"
          size="sm"
          disabled={page >= totalPages}
          onClick={() => go(page + 1)}
        >
          Next
          <ChevronRight size={14} strokeWidth={1.5} />
        </Button>
      </div>
    </div>
  );
}
